// extracted by mini-css-extract-plugin
module.exports = {"Errors":"StoreSocialMediaForm_Errors__2_8P0"};